export const SET_MODERATION_COUNTER = 'SET_MODERATION_COUNTER';